import { inject, Injectable } from '@angular/core';
import { CHANNEL } from '../config';

@Injectable({ providedIn: 'root' })
export class ChannelService {
  private channel = inject<string>(CHANNEL);

  get currentChannel(): string {
    return this.channel;
  }
}
